import { Box } from 'rebass/styled-components';

const Container = ({ children, ...props }) => (
  <Box width={[1, 1, '1280px']} maxWidth={["90%", "95%"]} mx="auto" {...props} px="3">
    {children}
  </Box>
);

export default Container;
